<template>
  <div>
    <div v-if="sectionInfo && isVisible" :class="multiSectionClass" :style="multiSectionColor"
         v-on-display="{sectionInfo, context: this}">
     <!-- title -->
      <div class="title" v-if="!isHiddenTitle">
        <template v-if="isSearchView">
          <h2 v-band-title class="title-area" tabindex="0">
            <span class="label" v-html="changColorSearchWord(sectionInfo.title)"></span>
            <span v-if="hasCount" class="count">{{sectionInfo.count | setNumberCommas}}</span>
          </h2>
        </template>
        <template v-else>
          <h2 v-band-title class="title-area" tabindex="0">
            <span class="label">{{multiSectionTitle}}</span>
          </h2>
        </template>
      </div>
      <!-- title end -->
      <template v-if="isSearchView || isPrerenderer">
        <CellList :cell-list="cellList" :title='multiSectionTitle' :thumbnail-info="thumbnailInfo" :search-word="searchWord"/>
      </template>
      <template v-else>
        <lazy-component @show="setData()">
          <template v-if="cellList.length === 0 && hasEmptyMessage">
            <div class="no-data">
              <p v-band-title>
                <span>{{emptyCellMessage}}</span>
              </p>
            </div>
          </template>
          <template v-else>
            <CellList :cell-list="cellList" :title='multiSectionTitle' :thumbnail-info="thumbnailInfo" :search-word="searchWord"/>
          </template>
        </lazy-component>
      </template>
      <template v-if="isSearchView">
        <a href="#" @click.prevent="viewAll(sectionInfo)" class="btn-more all">{{viewMoreTitle(sectionInfo, '더보기')}}</a>
      </template>
      <template v-else-if="isTagSearchView || isTagGroupSearchView">
        <a href="#" @click.prevent="viewAll(sectionInfo)" class="btn-more all">{{viewMoreTitle(sectionInfo, '전체보기')}}</a>
      </template>
      <template v-else-if="isMyView">
        <a href="#" v-if="cellList.length > 0" @click.prevent="viewMore(sectionInfo)" class="btn-more all">{{viewMoreTitle(sectionInfo, '더보기')}}</a>
      </template>
      <template v-else>
        <a href="#" v-if="hasViewMore" @click.prevent="viewMore(sectionInfo)" class="btn-more all">{{viewMoreTitle(sectionInfo, '더보기')}}</a>
      </template>
    </div>
    <template v-if="hasButtonInfo">
      <ppv-wrapper :button-info="buttonInfo"></ppv-wrapper>
    </template>
  </div>
</template>

<script>
import { bandTitle, onDisplay } from '@/common/resources/directives'
import { fetchOnContent } from '@/common/utils/request.common'
import { eventBodyListParser, getButtonInfo, getCellList } from '@/common/utils/gnb.fp'
import MultiSectionMixin from '@/mixins/multisection.mixin'
import CellList from '@/components/band/CellList'
import { isPrerenderer, setNumberCommas } from '@/common/utils/common'
import _ from 'lodash'
import { MY_BAND_DEFAULT_EMPTY_MESSAGE, MY_BAND_EMPTY_MESSAGE } from '@/common/resources/const'
import PpvWrapper from '@/components/band/wrapper/PpvWrapper'
import AdbrixUtils from '@/common/utils/adbrix.utils'
export default {
  name: 'TemplateMultiSection',
  mixins: [
    MultiSectionMixin
  ],
  filters: {
    setNumberCommas
  },
  directives: {
    bandTitle,
    onDisplay
  },
  components: {
    CellList,
    PpvWrapper
  },
  props: {
    sectionInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    },
    searchWord: {
      type: String
    }
  },
  data () {
    return {
      buttonInfo: null,
      cellList: [],
      isVisible: true,
      titleHidden: false,
      hasEmptyMessage: false,
      isPrerenderer: isPrerenderer()
    }
  },
  computed: {
    isSearchView () {
      return this.$route.name === 'search'
    },
    isTagSearchView () {
      return this.$route.name === 'search_tag'
    },
    isTagGroupSearchView () {
      return this.$route.name === 'search_tag_group'
    },
    isMyView () {
      return this.$route.name === 'my'
    },
    hasButtonInfo () {
      return this.buttonInfo !== null
    },
    isHiddenTitle () {
     return _.get(this.sectionInfo, 'cell_type', '') === 'band_61'
    },
    emptyCellMessage () {
      const emptyMessageList = MY_BAND_EMPTY_MESSAGE.filter((emptyMessage) => {
        const title = this.multiSectionTitle.replace(/(@\d@)|(@\^\d@)/gi, '')
        return emptyMessage.title.trim() === title.trim()
      })
      if (emptyMessageList.length > 0) {
        return _.get(emptyMessageList, '0.emptyMessage', MY_BAND_DEFAULT_EMPTY_MESSAGE)
      } else {
        return MY_BAND_DEFAULT_EMPTY_MESSAGE
      }
    },
    multiSectionClass () {
      const type = _.get(this.thumbnailInfo, 'type', '')
      return type === 'band_94' ? 'multi portrait-cell ranking-band' : `multi ${_.get(this.thumbnailInfo, 'componentName', '')}`
    }
  },
  methods: {
    setVisibleState () {
      const emptyCellList = this.cellList.length === 0
      if (emptyCellList) {
        if (this.isMyView) {
          this.isVisible = true
          this.hasEmptyMessage = true
        } else {
          this.isVisible = false
          this.hasEmptyMessage = false
        }
      } else {
        this.isVisible = true
      }
    },
    async setData () {
      if (this.cellList.length !== 0) return
      try {
        const response = await fetchOnContent(this.sectionInfo)
        this.cellList = getCellList(response)
        /** TODO: 검색 화면에서 보여질때에는
         *  현재 검색어, 카테고리, 각 밴드 cellList 의 첫 3 개의 상품정보를 추출해서 보낸다.
        **/
        this.buttonInfo = getButtonInfo(response)
        this.setVisibleState()
        if (this.isSearchView) {
          const targetCellList = _.cloneDeep(this.cellList).splice(0, 3)
          AdbrixUtils.sendSearchEvent({
            targetCellList,
            searchWord: this.searchWord
          })
        }
      } catch (e) {
        this.isVisible = false
      }
    },
    changColorSearchWord (title) {
      const searchWord = _.get(this.$route, 'query.searchWord', '')
      return _.replace(title, new RegExp(searchWord, 'g'), `<span class="col-vari-blue">${searchWord}</span>`)
    }
  },
  created () {
    if (this.isSearchView || this.isPrerenderer) {
      this.setData()
    }
  }
}
</script>
<style lang="css" src="@/assets/css/new_band.css"></style>
<style lang="css" scoped>
  /*.multi-chTemplate-comm.multi {width:100%; margin:0 auto; padding:50px 0; background-color: #faf8ff;}*/
  /*.multi-chTemplat-comm.multi > div {width:1240px; margin:0 auto;}*/

  .multi.landscape-cell {
    min-height: 238px;
  }
  .multi.circle-cell {
    min-height: 202px;
  }
  .multi.portrait-cell {
    min-height: 383px;
  }
</style>
